import _assign from "lodash/assign";
import _bindAll from "lodash/bindAll";
import _camelCase from "lodash/camelCase";
import _capitalize from "lodash/capitalize";
import _clone from "lodash/clone";
import _cloneDeep from "lodash/cloneDeep";
import _compact from "lodash/compact";
import _countBy from "lodash/countBy";
import _debounce from "lodash/debounce";
import _difference from "lodash/difference";
import _differenceBy from "lodash/differenceBy";
import _each from "lodash/each";
import _endsWith from "lodash/endsWith";
import _every from "lodash/every";
import _filter from "lodash/filter";
import _find from "lodash/find";
import _findIndex from "lodash/findIndex";
import _findKey from "lodash/findKey";
import _findLastIndex from "lodash/findLastIndex";
import _flatMap from "lodash/flatMap";
import _flatMapDeep from "lodash/flatMapDeep";
import _flatten from "lodash/flatten";
import _forEach from "lodash/forEach";
import _get from "lodash/get";
import _groupBy from "lodash/groupBy";
import _has from "lodash/has";
import _identity from "lodash/identity";
import _includes from "lodash/includes";
import _indexOf from "lodash/indexOf";
import _intersection from "lodash/intersection";
import _intersectionBy from "lodash/intersectionBy";
import _invert from "lodash/invert";
import _isArray from "lodash/isArray";
import _isBoolean from "lodash/isBoolean";
import _isEmpty from "lodash/isEmpty";
import _isEqual from "lodash/isEqual";
import _isFinite from "lodash/isFinite";
import _isFunction from "lodash/isFunction";
import _isNaN from "lodash/isNaN";
import _isNil from "lodash/isNil";
import _isNull from "lodash/isNull";
import _isNumber from "lodash/isNumber";
import _isObject from "lodash/isObject";
import _isPlainObject from "lodash/isPlainObject";
import _isString from "lodash/isString";
import _isUndefined from "lodash/isUndefined";
import _join from "lodash/join";
import _kebabCase from "lodash/kebabCase";
import _keyBy from "lodash/keyBy";
import _keys from "lodash/keys";
import _last from "lodash/last";
import _lowerCase from "lodash/lowerCase";
import _map from "lodash/map";
import _mapKeys from "lodash/mapKeys";
import _merge from "lodash/merge";
import _noop from "lodash/noop";
import _omit from "lodash/omit";
import _omitBy from "lodash/omitBy";
import _orderBy from "lodash/orderBy";
import _partial from "lodash/partial";
import _pick from "lodash/pick";
import _pickBy from "lodash/pickBy";
import _random from "lodash/random";
import _reduce from "lodash/reduce";
import _reject from "lodash/reject";
import _remove from "lodash/remove";
import _replace from "lodash/replace";
import _result from "lodash/result";
import _reverse from "lodash/reverse";
import _round from "lodash/round";
import _set from "lodash/set";
import _shuffle from "lodash/shuffle";
import _size from "lodash/size";
import _slice from "lodash/slice";
import _some from "lodash/some";
import _sortBy from "lodash/sortBy";
import _split from "lodash/split";
import _startCase from "lodash/startCase";
import _startsWith from "lodash/startsWith";
import _sum from "lodash/sum";
import _sumBy from "lodash/sumBy";
import _throttle from "lodash/throttle";
import _toLower from "lodash/toLower";
import _toUpper from "lodash/toUpper";
import _trim from "lodash/trim";
import _uniq from "lodash/uniq";
import _uniqBy from "lodash/uniqBy";
import _uniqWith from "lodash/uniqWith";
import _unset from "lodash/unset";
import _upperCase from "lodash/upperCase";
import _upperFirst from "lodash/upperFirst";
import _values from "lodash/values";
import _without from "lodash/without";
import _xor from "lodash/xor";

const lodashUtils = {
  assign: _assign,
  bindAll: _bindAll,
  camelCase: _camelCase,
  capitalize: _capitalize,
  clone: _clone,
  cloneDeep: _cloneDeep,
  compact: _compact,
  each: _each,
  every: _every,
  filter: _filter,
  find: _find,
  findIndex: _findIndex,
  flatMap: _flatMap,
  flatMapDeep: _flatMapDeep,
  flatten: _flatten,
  forEach: _forEach,
  get: _get,
  has: _has,
  includes: _includes,
  invert: _invert,
  isArray: _isArray,
  isBoolean: _isBoolean,
  isEmpty: _isEmpty,
  isEqual: _isEqual,
  isFunction: _isFunction,
  isNaN: _isNaN,
  isNull: _isNull,
  isNumber: _isNumber,
  isObject: _isObject,
  isPlainObject: _isPlainObject,
  isString: _isString,
  isUndefined: _isUndefined,
  join: _join,
  kebabCase: _kebabCase,
  keys: _keys,
  last: _last,
  lowerCase: _lowerCase,
  map: _map,
  noop: _noop,
  omit: _omit,
  omitBy: _omitBy,
  partial: _partial,
  pick: _pick,
  pickBy: _pickBy,
  random: _random,
  remove: _remove,
  replace: _replace,
  result: _result,
  reverse: _reverse,
  shuffle: _shuffle,
  size: _size,
  sortBy: _sortBy,
  split: _split,
  startCase: _startCase,
  toLower: _toLower,
  toUpper: _toUpper,
  trim: _trim,
  uniq: _uniq,
  uniqWith: _uniqWith,
  uniqBy: _uniqBy,
  unset: _unset,
  set: _set,
  upperCase: _upperCase,
  throttle: _throttle,
  debounce: _debounce,
  identity: _identity,
  round: _round,
  xor: _xor,
  isNil: _isNil,
  mapKeys: _mapKeys,
  orderBy: _orderBy,
  merge: _merge,
  difference: _difference,
  differenceBy: _differenceBy,
  reduce: _reduce,
  intersectionBy: _intersectionBy,
  values: _values,
  some: _some,
  upperFirst: _upperFirst,
  groupBy: _groupBy,
  reject: _reject,
  startsWith: _startsWith,
  endsWith: _endsWith,
  keyBy: _keyBy,
  findKey: _findKey,
  findLastIndex: _findLastIndex,
  slice: _slice,
  intersection: _intersection,
  countBy: _countBy,
  sumBy: _sumBy,
  sum: _sum,
  isFinite: _isFinite,
  indexOf: _indexOf,
  without: _without,
};

export default lodashUtils;

export const assign = _assign;
export const bindAll = _bindAll;
export const camelCase = _camelCase;
export const capitalize = _capitalize;
export const clone = _clone;
export const cloneDeep = _cloneDeep;
export const compact = _compact;
export const each = _each;
export const every = _every;
export const filter = _filter;
export const find = _find;
export const findIndex = _findIndex;
export const flatMap = _flatMap;
export const flatMapDeep = _flatMapDeep;
export const flatten = _flatten;
export const forEach = _forEach;
export const get = _get;
export const has = _has;
export const includes = _includes;
export const invert = _invert;
export const isArray = _isArray;
export const isBoolean = _isBoolean;
export const isEmpty = _isEmpty;
export const isEqual = _isEqual;
export const isFunction = _isFunction;
export const isNaN = _isNaN;
export const isNull = _isNull;
export const isNumber = _isNumber;
export const isObject = _isObject;
export const isPlainObject = _isPlainObject;
export const isString = _isString;
export const isUndefined = _isUndefined;
export const join = _join;
export const kebabCase = _kebabCase;
export const keys = _keys;
export const last = _last;
export const lowerCase = _lowerCase;
export const map = _map;
export const noop = _noop;
export const omit = _omit;
export const omitBy = _omitBy;
export const partial = _partial;
export const pick = _pick;
export const pickBy = _pickBy;
export const random = _random;
export const remove = _remove;
export const replace = _replace;
export const result = _result;
export const reverse = _reverse;
export const shuffle = _shuffle;
export const size = _size;
export const sortBy = _sortBy;
export const split = _split;
export const startCase = _startCase;
export const toLower = _toLower;
export const toUpper = _toUpper;
export const trim = _trim;
export const uniq = _uniq;
export const uniqWith = _uniqWith;
export const uniqBy = _uniqBy;
export const unset = _unset;
export const set = _set;
export const upperCase = _upperCase;
export const throttle = _throttle;
export const debounce = _debounce;
export const identity = _identity;
export const round = _round;
export const xor = _xor;
export const isNil = _isNil;
export const mapKeys = _mapKeys;
export const orderBy = _orderBy;
export const merge = _merge;
export const difference = _difference;
export const differenceBy = _differenceBy;
export const reduce = _reduce;
export const intersectionBy = _intersectionBy;
export const values = _values;
export const some = _some;
export const upperFirst = _upperFirst;
export const groupBy = _groupBy;
export const reject = _reject;
export const startsWith = _startsWith;
export const endsWith = _endsWith;
export const keyBy = _keyBy;
export const findKey = _findKey;
export const findLastIndex = _findLastIndex;
export const slice = _slice;
export const intersection = _intersection;
export const countBy = _countBy;
export const sumBy = _sumBy;
export const sum = _sum;
export const isFinite = _isFinite;
export const indexOf = _indexOf;
export const without = _without;
